import { useState } from 'react';
import { page01Example } from '../../../fixtures/page01/design-data';
import { Icon, Modal } from '../ui/Primitives';
import '../ui/primitives.css';
import './platform-header.css';
import { platformNavigation, platformRoutes } from './platform-routes';

/** Shared site navigation. Only implemented pages have destinations. */
export function PlatformHeader({
  activePage,
  explain,
  monitoringMode = 'monitor',
  brandPresentation = 'bitmap',
}: {
  readonly activePage:
    'overview' | 'workspace' | 'monitoring' | 'capability-equipment' | 'scenario-center';
  readonly explain?: (title: string, body: string) => void;
  readonly monitoringMode?: 'monitor' | 'fire-signals' | 'public-regional';
  readonly brandPresentation?: 'bitmap' | 'text';
}) {
  const [notice, setNotice] = useState<{ title: string; body: string } | null>(null);
  const activeIndex =
    activePage === 'overview'
      ? 0
      : activePage === 'monitoring'
        ? 1
        : activePage === 'scenario-center'
          ? 2
          : activePage === 'capability-equipment'
            ? 4
            : 3;
  function showNotice(name: string) {
    const body =
      '该功能页面尚未开放。请使用导航中的已开放功能区；厂商端与管理员端使用各自的独立入口。';
    if (explain) explain(name, body);
    else setNotice({ title: name, body });
  }
  return (
    <div className="p01 platform-header">
      <a
        className="p01-skip"
        href={
          activePage === 'overview'
            ? '#p01-main'
            : activePage === 'monitoring'
              ? '#nm-main'
              : activePage === 'scenario-center'
                ? '#scc-content'
                : activePage === 'capability-equipment'
                  ? '#ca-main'
                  : '#mw-context'
        }
      >
        跳转到主要内容
      </a>
      <header id="Z00" className="p01-brandbar">
        <a
          className="p01-brand-lockup"
          href={platformRoutes.overview}
          aria-label="AI消防+救援 综合态势"
        >
          {brandPresentation === 'text' ? (
            <strong className="scc-text-brand">AI消防 + 救援</strong>
          ) : (
            <img src="/page01/Brand_Lockup_Reference.png" alt="AI消防+救援 · AI Fire + Rescue" />
          )}
        </a>
        <span className="p01-region">
          <Icon name="pin" />
          消防员端 · 示范区域
        </span>
        <span className="p01-demo-label">
          {activePage === 'monitoring'
            ? monitoringMode === 'public-regional'
              ? '公开天气 · 本地核查闭环'
              : monitoringMode === 'fire-signals'
                ? '卫星历史研究 · 非实时'
                : '本地合成监测 · 非运营'
            : activePage === 'scenario-center'
              ? '合成场景 · 只读研究 · 非行动授权'
              : activePage === 'capability-equipment'
                ? '本地合成数据 · 非行动授权'
                : '视觉演示 · 示例数据 · 非实时'}
        </span>
        {activePage === 'monitoring' ? (
          <span>
            {monitoringMode === 'public-regional'
              ? '数据时间与覆盖范围见区域工作台'
              : monitoringMode === 'fire-signals'
                ? '独立火情未核实'
                : '时间与范围见后端摘要'}
          </span>
        ) : activePage === 'capability-equipment' ? (
          <span>本地合成 Owner · 非运行数据</span>
        ) : activePage === 'scenario-center' ? (
          <span>来源绑定知识 · 非实时</span>
        ) : (
          <time>示例时间 {page01Example.context.time}</time>
        )}
        <span className="p01-user">
          <Icon name="user" />
          <span>
            <strong>
              {activePage === 'monitoring' && monitoringMode === 'public-regional'
                ? '本地开发操作员'
                : '值守人员（示例）'}
            </strong>
            <small>
              {activePage === 'monitoring' && monitoringMode === 'public-regional'
                ? '内部核查记录'
                : '指挥调度中心'}
            </small>
          </span>
        </span>
      </header>
      <nav id="Z01" className="p01-nav" aria-label="一级导航">
        {platformNavigation.map(({ label: name, icon, href }, index) =>
          href ? (
            <a key={name} href={href} aria-current={index === activeIndex ? 'page' : undefined}>
              <Icon name={icon} />
              {name}
            </a>
          ) : (
            <button key={name} type="button" onClick={() => showNotice(name)}>
              <Icon name={icon} />
              {name}
            </button>
          ),
        )}
      </nav>
      {notice && (
        <Modal title={notice.title} close={() => setNotice(null)}>
          <p>{notice.body}</p>
        </Modal>
      )}
    </div>
  );
}
